import { BasicPage } from "../components/BasicPage";
import Person from "@mui/icons-material/Person";

export const GroupsRolesPage = () => {
  return <BasicPage title="Under construction" icon={<Person />} />;
};
